declare global {
  interface Window {
    yotpo: any;
    Yotpo: any;
  }
}

async function waitForGlobal(key: string) {
  const ms = 50;
  return await new Promise<boolean>(function check(resolve) {
    if ((window as any)[key]) {
      // Let script finish init
      return setTimeout(() => {
        return resolve(true);
      }, ms);
    }
    setTimeout(function () {
      check(resolve);
    }, ms);
  });
}

export { waitForGlobal };
